import { render, staticRenderFns } from "./IdeaTubes.vue?vue&type=template&id=617cfb96&"
import script from "./IdeaTubes.vue?vue&type=script&lang=js&"
export * from "./IdeaTubes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports